const environment = {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_FILE_UPLOAD_API_URL: process.env.REACT_APP_FILE_UPLOAD_API_URL,
  REACT_APP_CHAT_APP_URL: process.env.REACT_APP_CHAT_APP_URL,
  REACT_APP_KAIRA_API_BASE_URL: process.env.REACT_APP_KAIRA_API_BASE_URL,
  REACT_APP_API_KEY: process.env.REACT_APP_API_KEY,
  REACT_APP_GOODFLIP_URL: process.env.REACT_APP_GOODFLIP_URL,
  AZURE_STORAGE_ACCOUNT: process.env.REACT_APP_AZURE_STORAGE_ACCOUNT,
  REACT_APP_GROWTHBOOK_API_HOST: process.env.REACT_APP_GROWTHBOOK_API_HOST,
  REACT_APP_GROWTHBOOK_CLIENT_KEY: process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY,
};

export default environment;
